import { currencyToNum } from "../utils/transformators";

// save new US position
export const saveNewUSposition = async (
  axiosPrivate,
  USpositionData,
  paymenttermData,
  setReloadlistdata,
  reloadlistdata,
  setSPM,
  setShowSPM,
  showSPM,
  clearUSPosition
) => {
  try {
    const response = await axiosPrivate.post("/api/positions/addnewUSposition", { USpositionData });
    if (response.data.message !== "Saved") {
      setSPM(response.data.message);
      setShowSPM(!showSPM);
    }
    if (response.data.message === "Saved") {
      setReloadlistdata(!reloadlistdata);
      const response1 = await axiosPrivate.post("/api/positions/addUSpospayterms", {
        paymenttermData,
        positionID: response.data.positionID,
      });
      if (response1.data.message === "Saved") {
        setSPM(response.data.message);
        setShowSPM(!showSPM);
        clearUSPosition();
      }
    }
  } catch (err) {
    console.error(err);
  }
};

// Reduce edits preparing for Save Edits
function reduceEdits(arr) {
  const map = new Map();
  for (const obj of arr) {
    const existing = map.get(obj.name);
    if (!existing || obj.editID > existing.editID) {
      map.set(obj.name, obj);
    }
  }
  return Array.from(map.values());
}

/// Save Edits for existing position
export const saveEdits = async (
  positionEdits,
  axiosPrivate,
  positiontoedit,
  setReloadlistdata,
  setSPM,
  setShowSPM,
  paymenttermData,
  priceafterintins
) => {
  console.log(paymenttermData);
  const edits = reduceEdits(positionEdits.current);
  let editvalues = edits.map((item) => (item.nameID ? { [item.nameID]: item.valueID } : { [item.name]: item.num }));
  // filter out supplierID, payType, portion, termdays
  const filtered = editvalues.filter((obj) => {
    const key = Object.keys(obj)[0]; // each object only has one key
    return (
      key !== "supplierID" &&
      !key.includes("payType") &&
      !key.includes("portion") &&
      !key.includes("termdays") &&
      !key.includes("addrow") &&
      !key.includes("delrow")
    );
  });
  filtered.push({ ["priceafterintins"]: currencyToNum(priceafterintins) });
  console.log(filtered);
  try {
    const response = await axiosPrivate.post("/api/positions/updateUSposition", {
      data: filtered,
      positiontoedit: positiontoedit,
      paymenttermData: paymenttermData,
    });
    if (response.data.message === "Edits Saved") {
      setReloadlistdata((prev) => !prev);
      setSPM(response.data.message);
      setShowSPM((prev) => !prev);
    }
  } catch (err) {
    console.error(err);
  }
};

// save new Spain position
export const saveNewSPposition = async (
  axiosPrivate,
  positionData,
  paymenttermData,
  setReloadlistdata,
  reloadlistdata,
  setSPM,
  setShowSPM,
  showSPM,
  clearSPPosition
) => {
  try {
    const response = await axiosPrivate.post("/api/positions/addnewSPposition", { positionData });
    if (response.data.message !== "Saved") {
      setSPM(response.data.message);
      setShowSPM(!showSPM);
    }
    if (response.data.message === "Saved") {
      setReloadlistdata(!reloadlistdata);
      const response1 = await axiosPrivate.post("/api/positions/addSPpospayterms", {
        paymenttermData,
        positionID: response.data.positionID,
      });
      if (response1.data.message === "Saved") {
        setSPM(response.data.message);
        setShowSPM(!showSPM);
        clearSPPosition();
      }
    }
  } catch (err) {
    console.error(err);
  }
};

/// Save Edits for existing position
export const saveEditsSP = async (
  positionEdits,
  axiosPrivate,
  positiontoedit,
  setReloadlistdata,
  setSPM,
  setShowSPM,
  paymenttermData,
  priceafterintins
) => {
  console.log(paymenttermData);
  const edits = reduceEdits(positionEdits.current);
  let editvalues = edits.map((item) => (item.nameID ? { [item.nameID]: item.valueID } : { [item.name]: item.num }));
  // filter out supplierID, payType, portion, termdays
  const filtered = editvalues.filter((obj) => {
    const key = Object.keys(obj)[0]; // each object only has one key
    return (
      key !== "supplierID" &&
      !key.includes("payType") &&
      !key.includes("portion") &&
      !key.includes("termdays") &&
      !key.includes("addrow") &&
      !key.includes("delrow")
    );
  });
  filtered.push({ ["priceafterintins"]: currencyToNum(priceafterintins) });
  console.log(filtered);
  try {
    const response = await axiosPrivate.post("/api/positions/updateSPposition", {
      data: filtered,
      positiontoedit: positiontoedit,
      paymenttermData: paymenttermData,
    });
    if (response.data.message === "Edits Saved") {
      setReloadlistdata((prev) => !prev);
      setSPM(response.data.message);
      setShowSPM((prev) => !prev);
    }
  } catch (err) {
    console.error(err);
  }
};
